import React, { useEffect, useState } from "react";
import { Form } from "antd";
import ProfileInput from "../components/ProfileInput";
import { Section, SectionTitle, SectionDescription, FormGroup, InputGroup, ButtonWrapper } from "../styles";
import { StyledButton } from "../../../components/styles";
import { useAppSelector, useAppDispatch } from "../../../utils/hooks/redux";
import { updateAdminProfileThunkAsync } from "../../../redux/features/auth/authAsyncThunk";

interface PersonalSettingsProps { }

const PersonalSettings: React.FC<PersonalSettingsProps> = () => {
  const { userAuthInfo } = useAppSelector((state) => state.auth);
  const dispatch = useAppDispatch();
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    form.setFieldsValue({
      name: (userAuthInfo?.firstName ?? "") + " " + (userAuthInfo?.lastName ?? ""),
      email: userAuthInfo?.email ?? "",
    });
  }, [userAuthInfo]);

  const handleSubmit = async () => {
    try {
      setIsLoading(true);
      const values = await form.validateFields();
      const { name, email } = values;
      const [firstName, lastName] = name.split(" ");
      await dispatch(updateAdminProfileThunkAsync({ firstName, lastName, email })).unwrap();
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Section>
      <SectionTitle>Personal Settings</SectionTitle>
      <SectionDescription>You can update your display name, but your email is permanently linked to your profile and cannot be changed.</SectionDescription>
      <Form form={form} layout="vertical" disabled={isLoading}>
        <FormGroup>
          <InputGroup>
            <ProfileInput label="Name" name="name" placeholder="Enter your name" rules={[{ required: true, message: "Please enter name!" }]} />
          </InputGroup>
          <InputGroup>
            <ProfileInput name="email" label="Email" placeholder="Email address" disabled />
          </InputGroup>
        </FormGroup>
      </Form>
      <ButtonWrapper>
        <StyledButton type="primary" onClick={handleSubmit} loading={isLoading}>
          Save Personal Settings
        </StyledButton>
      </ButtonWrapper>
    </Section>
  );
};

export default PersonalSettings;
